import { Link } from "@tanstack/react-router"
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  H1,
} from "@motleyhand/design"
import { ApiFormWrapper, FormError, FormInput, FormSubmitButton } from "@/form"
import { useRequestResetPasswordMutation } from "@/auth"

export default function RequestResetPassword() {
  const [requestResetPassword, { isSuccess, reset }] =
    useRequestResetPasswordMutation()

  return (
    <div>
      <H1>Reset Password</H1>
      {isSuccess ? (
        <Card>
          <CardContent>
            <p>
              If an account matching your email exists, then an email was just
              sent that contains a link that you can use to reset your password.
            </p>
            <p>
              If you don’t receive an email please check your spam folder or{" "}
              <Link to="." onClick={reset}>
                try again
              </Link>{" "}
              in 5 minutes .
            </p>
          </CardContent>
        </Card>
      ) : (
        <Card>
          <CardHeader>
            <CardTitle>
              Enter your email address and we will send you a link to reset your
              password.
            </CardTitle>
          </CardHeader>
          <CardContent>
            <ApiFormWrapper
              defaultValues={{
                email: "",
              }}
              action={requestResetPassword}
              resetOnSuccess
            >
              <FormInput
                type="email"
                name="email"
                placeholder="Email"
                required
                autoFocus
                className="mb-4 w-full"
              />
              <FormError />
              <FormSubmitButton className="w-full">
                Send password reset email
              </FormSubmitButton>
            </ApiFormWrapper>
          </CardContent>
        </Card>
      )}
    </div>
  )
}
